// Best-effort Google Ads conversion ping for buy clicks. Buy CTAs are real
// anchors — this must never gate or delay navigation: with gtag.js ad-blocked
// the inline stub still exists but its event_callback never fires.
const SEND_TO = 'AW-18066227851/eSOmCOHRtZYcEIuF06ZD';

export default function reportBuyConversion() {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: SEND_TO,
      transport_type: 'beacon',
    });
  }
}
